var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 125,
    viewBox: "0 0 126 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_708_1975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7021 55.9729C47.5917 51.1256 52.2685 46.24 58.8332 46.388C65.3264 46.5351 69.6122 51.523 70.3857 55.9697C62.4979 52.4818 54.6123 52.4828 46.7021 55.9729Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6928 69.3467C70.6928 70.3662 70.6992 71.3346 70.6843 72.3019C70.6833 72.4106 70.5927 72.5469 70.5032 72.6226C67.8676 74.8385 64.8516 76.2394 61.4425 76.7646C56.9084 77.4635 52.6759 76.607 48.781 74.1961C47.77 73.5697 46.8463 72.8026 45.9014 72.1134C47.167 70.8509 48.3612 69.6599 49.5374 68.4859C50.2426 68.9791 50.9415 69.5331 51.6989 69.9901C57.3388 73.3928 64.6939 72.1208 68.8786 67.037C68.9382 66.9656 68.9851 66.8772 69.0576 66.824C69.1332 66.7686 69.2323 66.7462 69.3218 66.71C69.3527 66.7877 69.408 66.8655 69.4091 66.9443C69.4176 67.4355 69.4134 67.9276 69.4134 68.4198C69.4134 69.1592 69.5924 69.3413 70.3232 69.3456C70.4286 69.3456 70.533 69.3456 70.6907 69.3456L70.6928 69.3467Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5278 48.5511C62.4387 43.967 54.6937 43.9425 49.5833 48.5384C48.3901 47.3462 47.198 46.1552 46.0059 44.9641C52.172 38.8395 63.6106 37.8711 71.1265 44.9577C69.9355 46.1467 68.7434 47.3366 67.5278 48.5511Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.984 71.0446C38.3533 64.1891 38.3501 52.8167 44.984 45.958C46.1761 47.1491 47.3682 48.3401 48.5805 49.5503C46.3369 52.0944 45.1267 55.0848 45.132 58.5215C45.1363 61.9423 46.3487 64.92 48.5848 67.4565C47.3714 68.6657 46.1771 69.8546 44.984 71.0446Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6618 59.7885C63.6564 62.5904 61.3564 64.8819 58.5471 64.8808C55.7229 64.8808 53.4249 62.5723 53.4356 59.7459C53.4462 56.9494 55.757 54.6664 58.5694 54.6738C61.3745 54.6813 63.6671 56.9835 63.6618 59.7885Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5118 49.5517C69.7274 48.3373 70.9195 47.1462 72.135 45.9307C75.1904 49.278 76.847 53.2357 77.0707 57.8305H71.9422C71.7526 54.6824 70.6073 51.9157 68.5107 49.5507L68.5118 49.5517Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4009 61.6723H70.6847V59.1688H71.9545V62.9358H73.2383V59.1634H74.5082V61.6649H75.7919V59.172H77.0628C77.0703 59.2774 77.0842 59.3925 77.0842 59.5065C77.0852 60.835 77.0884 62.1634 77.0842 63.4919C77.0799 64.7085 76.2734 65.515 75.0568 65.5182C73.4194 65.5224 71.782 65.5235 70.1445 65.5182C68.9514 65.5139 68.1428 64.7043 68.1374 63.5122C68.1321 62.1698 68.1364 60.8286 68.1364 59.4862C68.1364 59.384 68.1364 59.2806 68.1364 59.1592H69.4009V61.6712V61.6723Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8455 70.2748C51.7141 69.4854 47.9141 65.9155 46.8945 61.75C51.1079 61.1491 56.0543 63.9701 55.8455 70.2748Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2461 70.3135C61.2951 67.8951 61.6935 65.643 63.544 63.9214C64.4165 63.1096 65.3839 62.4395 66.5323 62.0667C66.6186 62.039 66.7081 62.0198 66.8572 61.9814C66.8551 63.458 66.6591 64.9718 68.0472 66.0478C66.2425 68.252 63.9915 69.6529 61.2461 70.3135Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3807 61.4916C50.5462 60.4263 48.5934 60.3325 46.5011 60.4391C46.4776 59.5293 46.4478 58.6621 46.4414 57.7938C46.4414 57.6937 46.5511 57.5499 46.6481 57.4998C49.0323 56.2502 51.5572 55.4224 54.3111 54.9824C52.452 56.8116 51.7883 58.9327 52.3807 61.4927V61.4916Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7754 54.9805C65.5346 55.4183 68.0563 56.2493 70.4405 57.4893C70.5449 57.5437 70.6099 57.6726 70.694 57.7674C70.6749 57.7994 70.6546 57.8313 70.6355 57.8633C69.7086 57.8633 68.7818 57.8633 67.856 57.8633C67.0154 57.8633 66.8599 58.0199 66.8588 58.8604C66.8588 59.3782 66.8705 59.8959 66.8482 60.4126C66.8439 60.517 66.731 60.6704 66.633 60.7099C66.0172 60.9496 65.3919 61.1626 64.7441 61.3949C65.2992 58.951 64.6642 56.8246 62.7754 54.9815V54.9805Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7708 65.751C60.0655 67.3298 60.1039 68.931 59.8844 70.5556H57.2211C56.9846 68.9608 57.0517 67.3405 56.3262 65.7627C57.8272 66.2687 59.2452 66.2911 60.7708 65.751Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2237 76.9843H71.9922V69.3799H73.2237V76.9843Z",
    fill: "#0984FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5066 68.0529H70.7236V66.8203H74.5066V68.0529Z",
    fill: "#0984FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_708_1975",
    x: 0.00976562,
    y: 0,
    width: 125.076,
    height: 125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_708_1975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_708_1975",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterior);
export default __webpack_public_path__ + "static/media/interior.ff132f25fe137db9cd4640bbc4010a84.svg";
export { ForwardRef as ReactComponent };